module.exports = __webpack_public_path__ + "kudos_43.svg?d2c72dd127797f2603ed81ce0731eb01";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_43.svg
// module id = 143
// module chunks = 0